<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja"class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
          </li>
          <li class="item-link">
            <span>Extrato</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="box-title first">Extrato</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <p>
              Confira aqui seu extrato de Aldolares.
              <br>A cada compra sua aqui na Aldo você acumula aldolares que podem ser trocados por benefícios.
              <br>Acompanhe seu rendimento e aproveite essas vantagens que só o Aldo Crazy Card oferece pra você.
            </p>
          </div>
        </div>
        
        <div class="row">
          <div class="col-md-3">
            <div class="alert alert-info" role="alert">
              <i class="fa fa-money"></i> 
              <span><b> Saldo Atual: A$ {{formatN2(this.saldo)}}</b></span>             
            </div>
          </div>
        </div>

        <Loader v-if="loadingExtrato"/>

        <div class="row" v-if="!loadingExtrato">
          <div class="col-xs-12">
            <vue-good-table
              :columns="columns"
              :rows="extratos"
              :pagination-options="{
                          enabled: true,
                          mode: 'records',
                          perPage: 20,
                          position: 'top',
                          perPageDropdown: [40, 60],
                          dropdownAllowAll: false,
                          setCurrentPage: 2,
                          nextLabel: 'Próximo',
                          prevLabel: 'Anterior',
                          rowsPerPageLabel: 'Linhas por página',
                          ofLabel: 'de',
                          pageLabel: 'page',
                          allLabel: 'Todos',
                        }"
            >
              <template slot="table-row" slot-scope="props">
                <span
                  v-if="props.column.field == 'valor'"
                >{{ formatCurrency(props.formattedRow[props.column.field]) }}</span>
                <span v-else>{{props.formattedRow[props.column.field]}}</span>
              </template>
              <div slot="emptystate">Sem dados para exibição</div>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";

export default {
  name: "CrazyExtrato",
  props: {
    msg: String
  },
  components: {
    VueGoodTable
  },
  data() {
    return {
      columns: [
        { label: "Data", field: "data" },
        { label: "Descrição", field: "descricao" },
        { label: "Ativo", field: "ativo" },
        { label: "Valor", field: "valor" }
      ],
      extratos:[],
      saldo: 0,
      loadingExtrato: true
    };
  },
  mounted(){
    this.getDados();
    this.meuSaldo();
  },
  computed: {},
  methods: {},
  filters: {
    capitalize: function(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  methods: {
    formatCurrency: function(v) {
      v = v.toString().replace(',','.')
      var formato = {
        minimumFractionDigits: 2,
        style: "currency",
        currency: "BRL"
      };
      return parseFloat(v).toLocaleString("pt-BR", formato);
    },
    getDados: function() {
      const self = this;

      this.extratos = [];
       $.ajax({
        url: this.$apiUrl + "Extrato.svc/loadextrato",
        dataType: "json",
        type: "GET",
        xhrFields: { withCredentials: true },
        success: function(response){          
           //// console.log(response);        
          response.forEach((element, index) => {
            let item = {};
            item.data = element.Data.split(" ")[0];
            item.descricao = element.Descricao;
            item.ativo = element.Ativo;
            item.valor = element.Valor;                    
            self.extratos.push(item);
          });
          
          self.loadingExtrato = false
        },
        error: () => {
          swal({
            title: "Erro ao carregar extrato",
            icon: "warning"
          })
        }
    });
      // const Registros = [
      //   {
      //     data: "22/10/2018",
      //     descricao: "Valor Comprado + Bônus de A$ 1,05",
      //     ativo: "Sim",
      //     valor: 3920.79
      //   },
      //   {
      //     data: "10/10/2018",
      //     descricao: "Valor Comprado + Bônus de A$ 1,05",
      //     ativo: "Sim",
      //     valor: 1118.62
      //   },
      //   {
      //     data: "11/2/2019",
      //     descricao: "Valor Comprado + Bônus de A$ 1,05",
      //     ativo: "Sim",
      //     valor: -300.0
      //   },
      //   {
      //     data: "22/10/2018",
      //     descricao: "Valor Comprado + Bônus de A$ 1,05",
      //     ativo: "Sim",
      //     valor: 3920.79
      //   },
      //   {
      //     data: "10/10/2018",
      //     descricao: "Valor Comprado + Bônus de A$ 1,05",
      //     ativo: "Sim",
      //     valor: 1118.62
      //   },
      //   {
      //     data: "11/2/2019",
      //     descricao:
      //       "Saldo do Aldo Crazy Card após a Solicitação: 41464, é de A$ 115000,00",
      //     ativo: "Sim",
      //     valor: -300.0
      //   }
      // ];

      // return Registros;
    },
    meuSaldo : function(){  
      const self = this;
      
      $.ajax({
        url: this.$apiUrl + "Extrato.svc/loadsaldo",
        dataType: "json",
        type: "GET",
        xhrFields: { withCredentials: true },
        success: function(response){          
           //// console.log(response);        
          
            self.saldo = response;
 
          
        },
        error: () => {
          swal({
            title: "Erro ao carregar extrato",
            icon: "warning"
          })
        }
      });

    },
    formatN2: function(v) {
      var formato = {
        minimumFractionDigits: 2,
        style: "decimal"
      };
      return parseFloat(v).toLocaleString("pt-BR", formato);
    }
  }
};
</script>
